module.exports = __webpack_public_path__ + "img/kachel-HERZKREISLAUF-PROBALANCE.57d46333.png";